import {Component, OnInit, Input, Output} from '@angular/core';
import {Router} from "@angular/router";
import {StateService} from "../../services/state.service";
import {UtilService} from "../../services/util.service";
import {ProtestInfo} from "../../models/protest";
import {CaseDocketService} from "../../services/case-docket.service";


@Component({
    selector: 'app-dashboard-tree',
    templateUrl: './dashboard-tree.component.html',
    styleUrls: ['./dashboard-tree.component.scss'],
    standalone: false
})
export class DashboardTreeComponent implements OnInit {
  isDisplayed = true;
  constructor(private caseDocketService: CaseDocketService) { }
  @Input() protestParent: any;
  @Input() disableCaseDocketParent : boolean  = false;
  ngOnInit(): void {
  }

  redirectToCaseDocket(protest: ProtestInfo) {
    this.caseDocketService.redirectToCaseDocket(protest);
  }

  expandAndCollapse() {
    this.isDisplayed = this.isDisplayed ? false : true;
  }
}
